import { TrendingUp, MapPin, Clock, Home, Users, Award } from "lucide-react";

const CHRIS_PHOTO = "https://customer-assets.emergentagent.com/job_a0897f07-e635-4cd5-9eb9-21140ceaa71c/artifacts/uqs3oaza_brookebarclayphotography1-165.jpg";

export const SEOContent = () => {
  return (
    <section className="py-16 md:py-20 bg-white" data-testid="seo-content">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        
        {/* How Home Values Are Determined */}
        <div className="mb-16">
          <h2 className="text-2xl md:text-3xl font-serif text-[#132723] mb-6 text-center">
            How Home Values Are Determined Locally
          </h2>
          <p className="text-[#4d6153] text-center max-w-3xl mx-auto mb-8">
            Your home's value depends on several local factors that automated tools often miss. 
            A local expert review accounts for these nuances to give you a realistic pricing range.
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-[#f0efeb] p-6">
              <TrendingUp className="w-8 h-8 text-[#00453d] mb-3" />
              <h3 className="font-semibold text-[#132723] mb-2">Market Conditions</h3>
              <p className="text-sm text-[#4d6153]">
                Current buyer demand, inventory levels, and recent comparable sales in your specific neighborhood.
              </p>
            </div>
            <div className="bg-[#f0efeb] p-6">
              <MapPin className="w-8 h-8 text-[#00453d] mb-3" />
              <h3 className="font-semibold text-[#132723] mb-2">Location</h3>
              <p className="text-sm text-[#4d6153]">
                School districts, proximity to amenities, neighborhood trends, and local development plans.
              </p>
            </div>
            <div className="bg-[#f0efeb] p-6">
              <Home className="w-8 h-8 text-[#00453d] mb-3" />
              <h3 className="font-semibold text-[#132723] mb-2">Condition</h3>
              <p className="text-sm text-[#4d6153]">
                Updates, renovations, maintenance level, and how your home compares to recent sales.
              </p>
            </div>
            <div className="bg-[#f0efeb] p-6">
              <Clock className="w-8 h-8 text-[#00453d] mb-3" />
              <h3 className="font-semibold text-[#132723] mb-2">Timing</h3>
              <p className="text-sm text-[#4d6153]">
                Seasonal patterns, interest rates, and how quickly you need to sell affect optimal pricing.
              </p>
            </div>
          </div>
        </div>

        {/* Areas Served */}
        <div className="mb-16">
          <h2 className="text-2xl md:text-3xl font-serif text-[#132723] mb-6 text-center">
            Areas We Serve
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-[#f0efeb] p-6">
              <h3 className="font-semibold text-[#132723] mb-3">Grays Harbor County</h3>
              <p className="text-[#4d6153] text-sm leading-relaxed">
                Aberdeen, Hoquiam, Montesano, Ocean Shores, Westport, Elma, McCleary, Cosmopolis, 
                and all surrounding communities. Deep local knowledge of waterfront properties, 
                rural acreage, and in-town homes.
              </p>
            </div>
            <div className="bg-[#f0efeb] p-6">
              <h3 className="font-semibold text-[#132723] mb-3">Pacific County</h3>
              <p className="text-[#4d6153] text-sm leading-relaxed">
                Long Beach Peninsula, Raymond, South Bend, Tokeland, and coastal communities. 
                Expertise in vacation rentals, beach properties, and investment opportunities 
                along the Washington coast.
              </p>
            </div>
          </div>
        </div>

        {/* About the Team */}
        <div className="bg-[#132723] p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img 
                src={CHRIS_PHOTO} 
                alt="Chris Pierog - Spivey Realty Group" 
                className="w-full max-w-sm mx-auto"
              />
            </div>
            <div className="text-white">
              <h2 className="text-2xl md:text-3xl font-serif mb-4">
                Chris Pierog & Spivey Realty Group
              </h2>
              <p className="text-white/80 mb-6">
                Spivey Realty Group is the top-producing real estate team in Grays Harbor, 
                with offices in Hoquiam, Aberdeen, Montesano, Ocean Shores, and Westport. 
                We've helped hundreds of families buy and sell homes across Southwest Washington.
              </p>
              
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <Award className="w-6 h-6 mx-auto mb-2 text-white/60" />
                  <p className="text-xl font-serif">Top 10</p>
                  <p className="text-xs text-white/60">Agent Yearly</p>
                </div>
                <div>
                  <Users className="w-6 h-6 mx-auto mb-2 text-white/60" />
                  <p className="text-xl font-serif">100+</p>
                  <p className="text-xs text-white/60">Happy Clients</p>
                </div>
                <div>
                  <Home className="w-6 h-6 mx-auto mb-2 text-white/60" />
                  <p className="text-xl font-serif">$50M+</p>
                  <p className="text-xs text-white/60">Sales Volume</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SEOContent;
